import { defineComponent as _defineComponent } from 'vue'
import BuilderEstimatorHouseSelectorMobile from "./BuilderEstimatorHouseSelectorMobile.vue";
  import BuilderEstimatorHouseSelectorDesktop from "./BuilderEstimatorHouseSelectorDesktop.vue";

  import type { BuilderInterfaceWithHouseDesigns } from "@/types/BuilderInterface";
  import type { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import { computed } from "vue";

  interface Props {
    builder?: BuilderInterfaceWithHouseDesigns;
    selectedHouse: HouseDesignInterface;
    isDesktop: boolean;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorHouseSlider',
  props: {
    builder: {},
    selectedHouse: {},
    isDesktop: { type: Boolean }
  },
  emits: ["update:selectHouse"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emit = __emit;

  const mobileTitle = computed(() => (props.isDesktop ? "Step 03 : " : ""));
  const mobileContentTitle = computed(() =>
    props.isDesktop ? "Select Design" : "Swipe to compare designs"
  );
  const builderLogo = computed(() => props.builder?.logo);
  const builderHouses = computed(() => props.builder?.houses);

  const onSelectHouse = (houseId: string) => {
    emit("update:selectHouse", houseId);
  };

const __returned__ = { props, emit, mobileTitle, mobileContentTitle, builderLogo, builderHouses, onSelectHouse, BuilderEstimatorHouseSelectorMobile, BuilderEstimatorHouseSelectorDesktop, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})